// remove object with duplicate value from array by key
export const uniqueBy =
  (k: string, s = new Set()) =>
  (o: { [key: string]: string}) =>
    !s.has(o[k]) && s.add(o[k]);